import { useMutation, useQueryClient } from '@tanstack/react-query'

import { request } from '../../../lib/axios'
import { useUserStore } from 'Stores/userStoreModuleFed'

export type DomainPixelObject = {
  pixelId: number
  domainId: number
}

export const setFacebookPixelsToDomains = async (
  accountId: number,
  connectionId: number,
  pixels: DomainPixelObject[]
) => {
  return (await request({
    url: `/accounts/${accountId}/facebook/${connectionId}/pixels/domains`,
    method: 'PUT',
    data: { pixels },
  })) as string[]
}

export const useSetFacebookPixelsToDomains = () => {
  const { accountId } = useUserStore()
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: ['setFacebookPixelsToDomains'],
    mutationFn: ({ connectionId, pixels }: { connectionId: number; pixels: DomainPixelObject[] }) =>
      setFacebookPixelsToDomains(accountId, connectionId, pixels),
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: ['getPlatformsConnections'] })
    },
  })
}
